

import FormContact from "@/vue/components/FormContactV2.vue";



const fetchLinksForPagination = () => {
    const id = document.querySelector('#my-property-id').value;

    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(String(prop)),
    });

    axios.get(route('api.properties.fetchLinksForPagination', id), {
        params: {
            _: params._,
        }
    }).then(({data: {currentNumber, total, urlNext, urlPrevious}}) => {
        if (currentNumber) {
            document.querySelectorAll('.currentNumber').forEach((el) => {
                el.textContent = currentNumber;
            })
        }

        if (urlNext) {
            document.querySelectorAll('.urlNext').forEach((el) => {
                el.setAttribute('href', urlNext);
            })
        }

        if (urlPrevious) {
            document.querySelectorAll('.urlPrevious').forEach((el) => {
                el.setAttribute('href', urlPrevious);
            })
        }

        if (parseInt(total) > 0) {
            document.querySelectorAll('.total').forEach((el) => {
                el.textContent = total;
            })

            document.querySelectorAll('[data-with-results]').forEach((el) => {
                el.classList.remove('d-none');
            });

            document.querySelector('[data-without-results]').classList.add('d-none');
        }
    });
}

function copyText() {
    let link = document.getElementById("copyLinkToClipboard").value;
    console.log('current link', link)
    navigator.clipboard.writeText(link);
    toastSuccess('Link copiado')
}

/**
 * @param {HTMLImageElement} that
 */
function onErrorImage(that) {
    that.onerror = null;
    that.src = '/images/noLogo.svg';
    that.style.width = '400px';
    that.style.height = '400px';
}

window.onErrorImage = onErrorImage;

function listeningScroll() {
    if (window.scrollY > 150) {
        document.getElementById('navbar_top').classList.add('fixed-top');
        document.getElementById('navbar_top').classList.add('d-block');
        document.getElementById('navbar_top').classList.remove('d-none');

        // add padding top to show content behind navbar
        let navbar_height = document.querySelector('.navbar').offsetHeight;
        document.body.style.paddingTop = navbar_height + 'px';
    } else {
        document.getElementById('navbar_top').classList.remove('fixed-top');
        document.getElementById('navbar_top').classList.remove('d-block');
        document.getElementById('navbar_top').classList.add('d-none');
        // remove padding top from body
        document.body.style.paddingTop = '0';
    }
}

function videoUrl() {
    //Set videoAnchor
    let url = window.location.href.split("#")[0];

    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);

    let video = urlParams.get('video');

    if (!video) {
        window.history.pushState("", "", url + '&video=true#video');
    }
}

function toggleExcluded(adId) {
    const user = JSON.parse(document.querySelector('[name="data-user"]').value);
    if (!user) {
        const myModal = new window.bootstrap.Modal(document.getElementById('model-exclude'), {})
        myModal.toggle();
        return
    }

    axios.post(route('api.marked-ads.toggle-property-excluded-by-auth', adId)).then(({data: {message}}) => {
        // const elSwal = document.querySelector('.swal2-icon.swal2-icon-show')
        Swal.fire({
            title: "Imóvel excluído",
            html: message,
            iconHtml: '<img class="" style="width: 30px" src="/images/trash_new.svg" alt="">',
            confirmButtonText: "Fechar",
            customClass: {
                icon: 'border-blue'
            }
        }).then(() => {
            document.querySelector(`[data-property-ad-id="${adId}"]`)?.remove()
        });
    })
}

function getIndex() {
    setTimeout(() => {
        let active = document.querySelector('.swiper-fullscreen .swiper-slide-active')
        let dataIndex = active?.getAttribute('data-swiper-slide-index')
        let index = parseInt(dataIndex || 0);
        document.getElementById('index-foto').innerText = String(index + 1);
    }, 200)
}

const openFullScreen = () => {
    const swiperFullScreen = getSwiperFullScrren();

    getMainSwiper().then((mainSwiper) => {
        console.debug('current index on open', swiperFullScreen.activeIndex, mainSwiper.activeIndex);

        swiperFullScreen.slideTo(mainSwiper.activeIndex, 0)

        getIndex();
    });

    $('body').addClass('body-stuck');

    $('.fullscreen-wrapper').addClass('fullscreen-pop');

    $('.swiper-fullscreen')
        .addClass('d-block')
        .removeClass('d-none');

    $('.fullscreen-wrapper .targetfotos').addClass('btn-effect');

    $('.change-container')
        .removeClass('container')
        .addClass('container-fluid');

    $('.share')
        .addClass('d-none')
        .addClass('d-md-block');

    $('.fav')
        .addClass('d-none')
        .addClass('d-md-block');

    $('.wraper-fullscreen').addClass('d-flow-root');
}

const closeFullScreen = () => {
    console.debug('popoff');

    const swiperFullScreen = getSwiperFullScrren();

    getMainSwiper().then((mainSwiper) => {
        console.debug('current index on close', swiperFullScreen.activeIndex, mainSwiper.activeIndex);

        mainSwiper.slideTo(swiperFullScreen.activeIndex, 0);
    })

    $('body').removeClass('body-stuck');

    $('.fullscreen-wrapper').removeClass('fullscreen-pop');
    $('.fullscreen-wrapper .targetfotos').removeClass('btn-effect');
    $('.fullscreen-wrapper .targetvideos').removeClass('btn-effect');

    $('.change-container')
        .removeClass('container-fluid')
        .addClass('container');

    $('.video').addClass('d-none').removeClass('d-block');

    $('.swiper-fullscreen').addClass('d-none').removeClass('d-block');

    $('.share').removeClass('d-none');

    $('.fav').removeClass('d-none');

    $('.wraper-fullscreen').removeClass('d-flow-root');
}

const observerForCLoseFullScreen = () => {
    document.querySelectorAll('[data-action="pop-of-fullscreen"]')
        .forEach(el => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                closeFullScreen();
            });
        });

    document.addEventListener('keyup', (e) => {
        e.preventDefault();
        if (e.key === "Escape") {
            console.debug('Escape pressed');
            closeFullScreen();
        }
    });
}

setTimeout(() => {
    document.querySelector('[v-cloak]')?.removeAttribute('v-cloak')
}, 50)

$(document).ready(function () {
    $('.pop-fullscreen-video').click(function () {
        console.log('video');
        $('.fullscreen-wrapper').addClass('fullscreen-pop');
        $('.fullscreen-wrapper .targetvideos').addClass('btn-effect');
        $('.video').addClass('d-block').removeClass('d-none');
    });

    $('.pop-fullscreen-video-3d').click(function () {
        console.log('video-3d');
        $('.fullscreen-wrapper').addClass('fullscreen-pop');
        $('.fullscreen-wrapper .targetvideos-3d').addClass('btn-effect');
        $('.video-3d').addClass('d-block').removeClass('d-none');
    });

    $('.targetfotos').click(function () {
        $('.change-on-fullscreen-videos').removeClass('btn-effect');
        $('.targetfotos').addClass('btn-effect');
        $('.video').addClass('d-none').removeClass('d-block');
        $('.swiper-fullscreen').addClass('d-block').removeClass('d-none');

        $('.share').addClass('d-none');
        $('.fav').addClass('d-none');
    });

    $('.change-on-fullscreen-videos').click(function () {
        $('.change-on-fullscreen-videos').addClass('btn-effect');
        $('.targetfotos').removeClass('btn-effect');
        $('.swiper-fullscreen').addClass('d-none').removeClass('d-block');
        $('.video').addClass('d-block').removeClass('d-none');
    });

    //Check if url has video hash
    var hash = window.location?.hash;

    //Open video if hash is set
    if (hash === '#video') {
        //Open video
        console.debug('Video hash found');
        $('.pop-fullscreen-video').click();
    }

    var favLoading = false;

    var currentUrl = window.location.href;

    var missesUrl = route('myfavs');


});

document.addEventListener("DOMContentLoaded", function () {
    console.debug('DOM loaded');

    document.querySelector('#video-url')?.addEventListener('click', videoUrl);

    document.querySelectorAll('[data-get-index]').forEach(el => {
        el.addEventListener('click', getIndex)
    })

    window.addEventListener('scroll', () => listeningScroll())

    document.querySelectorAll('[data-trigger="copy"]').forEach(el => {
        el.addEventListener('click', function () {
            let copyText = document.querySelector(el.getAttribute('data-target'))?.innerText;
            console.debug('copyText', copyText);
            let textArea = document.createElement("textarea");
            textArea.value = copyText;

            // Avoid scrolling to bottom
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                let successful = document.execCommand('copy');
                let msg = successful ? 'successful' : 'unsuccessful';
                console.debug('Copying text command was ' + msg);
            } catch (err) {
                //
            }

            document.body.removeChild(textArea);
        });
    })

    setTimeout(() => {
        document.querySelectorAll('.pop-fullscreen-images').forEach(el => {
            el.addEventListener('click', (e) => {
                console.debug('pop-fullscreen-images');
                e.preventDefault();
                openFullScreen();
            });
        })
    }, 200);

    document.getElementById("copyLinkToClipboardDiv").addEventListener("click", copyText, false);

    let elPopUp = document.querySelector('#btn-open-full-screen');
    console.debug('elPopUp', elPopUp)
    elPopUp.addEventListener('click', (e) => {
        console.debug('pop-fullscreen-images');
        e.preventDefault();
        openFullScreen();
    });

    observerForCLoseFullScreen();

    fetchLinksForPagination();
});

window.videoUrl = videoUrl;

window.toggleExcluded = toggleExcluded

window.getIndex = getIndex;

new Vue({
    el: '.withRecaptcha',
    name: 'FormRecaptcha',
    components: {
        FormContact
    },
    data() {
        return {
            endpoint: '',
            redirect:'',
        }
    },
    mounted() {
        this.endpoint = JSON.parse(document.querySelector('#endpoint-vue').value)
        this.redirect = JSON.parse(document.querySelector('#redirect-vue').value)
    }
})


const phoneNumberVue = document.querySelectorAll(".phoneNumberDivVue");
Array.prototype.forEach.call(phoneNumberVue, (el) => new Vue({el}))


const el = document.querySelector('#contact_visit_or_recomend')

if (el) {
    new Vue({
        el,
        data() {
            return {
                recomend: null,
                modalOpen: document.querySelector('#session-modal-open')?.value === 'true',
            }
        },
        mounted() {

        },
        methods: {
            legislationString(url) {
                return HelperJS.legislationForPhoneN(url)
            }
        }
    })
}
